const directiveAdmins = {
  all_directive_admins: 'Todos los directivos',
  create: 'Crear Nuevo Directivo',
  firstname: 'Nombre',
  lastname: 'Apellido Paterno',
  lastname2nd: 'Apellido Materno',
  email: 'Correo Electrónico',
  dni: 'DNI',
  birth_date: 'Fecha de Nacimiento',
  school: 'Sede',
  general_information: 'Información General',
  select_school: 'Seleccionar Sede',
  search_by_name: 'Buscar por nombre',
  edit_directive: 'Editar Directivo',
  directive_information: 'Información del Directivo',
  impersonate: 'Impersonar',
  creation_date: 'Fecha de creación',
  last_access: 'Último acceso',
  without_last_access: 'No ha ingresado',
  state: 'Estatus',
  active: 'Activo',
  inactive: 'Inactivo',
  create_new_information: '🔑 Nueva contraseña',
  empty: 'Vacío',
};

export default directiveAdmins;
